import { useTranslation } from 'react-i18next';
import { localeFromSegment } from '../../../shared-site-web/locales.js';

/**
 * The active site language, derived from the URL-synced i18next instance.
 * Preserves the US English variant so /en-us pages resolve en-US mock data.
 * @returns {string}
 */
export function useSiteLang() {
	const { i18n } = useTranslation();
	return localeFromSegment(i18n.language || '');
}
